import React from "react";
import styled from "styled-components";
import Input from "./CurrencyInput";
import classnames from "classnames";
import { CONSTANTS } from "../common/constants";
import { createDataTestId, AutomationTestIdFeature, AutomationTestIdElementType } from "../../../utilities/automation"

const StyledInput = styled(Input)`
    input.has-label {
        padding-top: 21px;
    }

    .form-control {
        border: none;
        height: 50px;
    }
`;

export default (props) => {
    const { onChange, containerClassName, inputClassName, values, labels, placement = ''} = props;

    const inputProps = {
        showLabel: false,
        showCurrencyIcon: true,
        inputType: "number",
        onChange,
        inputClassName,
        required: true
    };

    return (
        <>
            <StyledInput
                id={values.LoanPurpose.value === CONSTANTS.PURCHASE ? "PurchasePrice" : "CurrentHomeValue"}
                containerClassName={classnames(containerClassName, "pl-0")}
                name={values.LoanPurpose.value === CONSTANTS.PURCHASE ? "purchasePrice" : "currentHomeValue"}
                dataTestId={createDataTestId({feature: AutomationTestIdFeature.MRQT_CALCULATOR, element: AutomationTestIdElementType.INPUT, placement, specifier: 'purchasePrice'})}
                value={values.LoanPurpose.value === CONSTANTS.PURCHASE ? values.PurchasePrice.value : values.CurrentHomeValue.value}
                label={labels[0]}
                {...inputProps} />
            <StyledInput
                id={values.LoanPurpose.value === CONSTANTS.PURCHASE ? "DownPayment" : "RefinanceAmount"}
                containerClassName={classnames(containerClassName, "pr-0")}
                name={values.LoanPurpose.value === CONSTANTS.PURCHASE ? "downPayment" : "refinanceAmount"}
                dataTestId={createDataTestId({feature: AutomationTestIdFeature.MRQT_CALCULATOR, element: AutomationTestIdElementType.INPUT, placement, specifier: 'downPayment'})}
                value={values.LoanPurpose.value === CONSTANTS.PURCHASE ? values.DownPayment.value : values.RefinanceAmount.value}
                label={labels[1]}
                {...inputProps} />
        </>
    );
};